import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import asset from '../../static/assets/spec-sheets/Storefront In-Store Place Based Billboards Specs 2026.pdf'

class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout
        head={{
          title: 'Storefront In-Store Place-Based Billboards Specs 2026',
        }}
      >
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">
                  Storefront In-Store Place-Based Billboards Specs 2026
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section
          id="storefront-in-store-place-based-billboards-specs-2026"
          className="text-center"
        >
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="container mt-5">
                  <h2 className="font-bold">
                    Storefront In-Store Place Based Billboards
                  </h2>
                  <p>PRODUCTION SPECIFICATIONS</p>
                  <div className="d-flex justify-content-center mt-4">
                    <a
                      class="link-btn-green"
                      href={asset}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
